export default "__VITE_ASSET__DPcjFsEG__"